/**
 * CargasPage — página raiz da rota /cargas (RF-M2-010).
 *
 * 🔴 Admin-only (RN-M2-001): toda a superfície de /cargas (leitura, criação,
 * stream, download do script) exige o grupo `admin`. Perfis consulta/editor não
 * veem a página (o guard de rota redireciona/oculta). O relatório de integridade
 * expõe caminhos com possível PII — por isso a leitura também é restrita.
 * ADR-038: o cartão "Planilha de instalações sem termo" (carga da planilha, prévia e confirmação).
 */

import { useState } from 'react';
import { useCargas } from '../hooks/useCargas';
import { CargasTable } from '../components/CargasTable';
import { NovaCargaCard } from '../components/NovaCargaCard';
import { RelatorioModal } from '../components/RelatorioModal';
import { ScriptDownloadButton } from '../components/ScriptDownloadButton';
import { PlanilhaInstalacoesCard } from '../components/PlanilhaInstalacoesCard';

export function CargasPage(): JSX.Element {
  const { itens, carregando, erro, recarregar } = useCargas();
  const [detalheId, setDetalheId] = useState<string | null>(null);

  return (
    <div>
      <h1 className="page-title">Cargas</h1>
      <p className="page-subtitle">
        Ingestão do acervo por upload na tela ou pelo script de importação. Restrito ao Administrador.
      </p>

      <NovaCargaCard onConcluido={recarregar} />

      <PlanilhaInstalacoesCard />

      <section className="card">
        <h2>Script de importação</h2>
        <p className="muted">
          Para remessas grandes ou conexões instáveis, use o script Python — ele gera o manifesto,
          envia cada arquivo pela URL de upload temporária (15 min) que a API gera para ele e reporta o progresso.
        </p>
        <ScriptDownloadButton />
      </section>

      <section className="card">
        <h2>Cargas registradas</h2>
        {carregando && <p className="muted">Carregando…</p>}
        {erro && <p className="notice">Não foi possível carregar as cargas.</p>}
        {!carregando && !erro && <CargasTable itens={itens} onDetalhe={setDetalheId} />}
      </section>

      <section className="card">
        <h2>Arquivos aguardando leitura</h2>
        <p className="muted">
          A leitura automática (extração) é disparada pelo pipeline após a conferência. Este painel
          é informativo — o processamento acontece em segundo plano.
        </p>
      </section>

      {detalheId && <RelatorioModal cargaId={detalheId} onFechar={() => setDetalheId(null)} />}
    </div>
  );
}
